module.exports = __webpack_public_path__ + "static/media/icon-support.f8b7f8d8.svg";